import { meta } from './meta';

export const classnamePrefix = `eapp-${meta.appAlias}`;
export const ICONS_URL = 'https://static.elfsight.com/icons/app-vimeo-gallery';

export const MOBILE_WIDTH_EXTRA_SMALL = 320;
export const MOBILE_WIDTH_SMALL = 380;
export const MOBILE_WIDTH_POPUP = 480;
export const MOBILE_WIDTH = 576;
export const TABLET_WIDTH = 768;
export const TABLET_WIDTH_LARGE = 880;
